import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import ReportService from "services/ReportService";
import { useDispatch } from "react-redux";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  data: [],
  careGiverExportData: [],
  programExportData: [],
  programParticipantExportData: [],
  programSessionExportData: [],
  sessionAttendanceExportData: [],
  sessionParticipantExportData: [],
  participantExportData: [],
  pendingParticipantExportData: [],
  groupParticipantExportData: [],
  groupleaderParticipantExportData: [],
  caregiverParticipantExportData: [],
};

export const getAgeReport = createAsyncThunk(
  "report/getAgeReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getAgeReport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProgramExport = createAsyncThunk(
  "report/getProgramExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getProgramExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCareGiverExport = createAsyncThunk(
  "report/getCareGiverExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getCareGiverExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProgramParticipantExport = createAsyncThunk(
  "report/getProgramParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getProgramParticipantExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProgramSessionExport = createAsyncThunk(
  "report/getProgramSessionExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getProgramSessionExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getSessionAttendanceExport = createAsyncThunk(
  "report/getSessionAttendanceExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getSessionAttendanceExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getSessionParticipantExport = createAsyncThunk(
  "report/getSessionParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getSessionParticipantExport(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getParticipantExport = createAsyncThunk(
  "report/getParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getParticipantExport(data);
      if (response.status) {
        console.log("P:", response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getPendingParticipantExport = createAsyncThunk(
  "report/getPendingParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getPendingParticipantExport(data);
      if (response.status) {
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getGroupParticipantExport = createAsyncThunk(
  "report/getGroupParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getGroupParticipantExport(data);
      if (response.status) {
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getGroupleaderParticipantExport = createAsyncThunk(
  "report/getGroupleaderParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getGroupleaderParticipantExport(
        data
      );
      if (response.status) {
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCaregiverParticipantExport = createAsyncThunk(
  "report/getCaregiverParticipantExport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReportService.getCaregiverParticipantExport(data);

      if (response.status) {
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ReportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAgeReport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getAgeReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.message = "";
      })
      .addCase(getAgeReport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getProgramExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getProgramExport.fulfilled, (state, action) => {
        state.loading = false;
        state.programExportData = action.payload;
        state.message = "";
      })
      .addCase(getProgramExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getCareGiverExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getCareGiverExport.fulfilled, (state, action) => {
        state.loading = false;
        state.careGiverExportData = action.payload;
        state.message = "";
      })
      .addCase(getCareGiverExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getProgramParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getProgramParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.programParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getProgramParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getProgramSessionExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getProgramSessionExport.fulfilled, (state, action) => {
        state.loading = false;
        state.programSessionExportData = action.payload;
        state.message = "";
      })
      .addCase(getProgramSessionExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getSessionAttendanceExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getSessionAttendanceExport.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionAttendanceExportData = action.payload;
        state.message = "";
      })
      .addCase(getSessionAttendanceExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getSessionParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getSessionParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getSessionParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.participantExportData = action.payload;
        state.message = "";
      })
      .addCase(getParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getPendingParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getPendingParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getPendingParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getGroupParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getGroupParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.groupParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getGroupParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getGroupleaderParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getGroupleaderParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.groupleaderParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getGroupleaderParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getCaregiverParticipantExport.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getCaregiverParticipantExport.fulfilled, (state, action) => {
        state.loading = false;
        state.caregiverParticipantExportData = action.payload;
        state.message = "";
      })
      .addCase(getCaregiverParticipantExport.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export default ReportSlice.reducer;
